import { Component, OnInit } from '@angular/core';
import { OtherChildTab, OtherTabList } from './other.const';
import { Router } from '@angular/router';

@Component({
  selector: 'settings-other',
  templateUrl: './other.component.html',
  styleUrls: ['./other.component.css'],
})
export class OtherComponent implements OnInit {
  public currentTab = OtherChildTab.Template;
  public readonly otherTabList = OtherTabList;

  constructor(private router: Router) {}

  ngOnInit() {}

  onChangeTab(tabId: OtherChildTab) {
    this.currentTab = tabId;

    this.router.navigate([tabId]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/other/other.component.ts